import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class Pip {

  #rmp;
  #onPipClickFn = null;
  #onPipClickSafariFn = null;
  #enterpictureinpictureFn = null;
  #leavepictureinpictureFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #enterpictureinpicture() {
    this.#rmp.dom.container.classList.add('rmp-pip-on');
    this.#rmp.dispatch('enterpictureinpicture');
  }

  #leavepictureinpicture() {
    this.#rmp.dom.container.classList.remove('rmp-pip-on');
    this.#rmp.dispatch('leavepictureinpicture');
  }

  #onPipClick(event) {
    FW.eventStopPrevent(event);
    Logger.print('pip', 'requesting PIP mode');
    if (!document.pictureInPictureElement) {
      this.#rmp.dom.video.requestPictureInPicture().then(() => {
      }).catch(event => {
        this.#rmp.rmpUtils.warning(1009, event);
      });
    } else {
      document.exitPictureInPicture().catch(warning => {
        console.warn(warning);
      });
    }
  }

  #onLoadedmetadataPiP() {
    if (document.pictureInPictureEnabled) {
      this.#rmp.rmpModuleManagement.appendToModuleBar('pip');
      this.wirePiPEvents();
      this.#onPipClickFn = this.#onPipClick.bind(this);
      FW.addEvents(['touchend', 'click'], this.#rmp.dom.pip, this.#onPipClickFn);
    }
  }

  #onPipClickSafari(event) {
    FW.eventStopPrevent(event);
    Logger.print('pip', 'requesting Safari PIP mode');
    let pipMode = 'picture-in-picture';
    if (this.#rmp.dom.video.webkitPresentationMode === 'picture-in-picture') {
      pipMode = 'inline';
    }
    this.#rmp.dom.video.webkitSetPresentationMode(pipMode);
  }

  #onLoadedmetadataPiPSafari() {
    this.#rmp.rmpModuleManagement.appendToModuleBar('pip');
    this.wirePiPEvents();
    this.#onPipClickSafariFn = this.#onPipClickSafari.bind(this);
    FW.addEvents(['touchend', 'click'], this.#rmp.dom.pip, this.#onPipClickSafariFn);
  }

  wirePiPEvents() {
    this.#enterpictureinpictureFn = this.#enterpictureinpicture.bind(this);
    this.#rmp.dom.video.addEventListener('enterpictureinpicture', this.#enterpictureinpictureFn);
    this.#leavepictureinpictureFn = this.#leavepictureinpicture.bind(this);
    this.#rmp.dom.video.addEventListener('leavepictureinpicture', this.#leavepictureinpictureFn);
  }

  unwirePiPEvents() {
    this.#rmp.dom.video.removeEventListener('enterpictureinpicture', this.#enterpictureinpictureFn);
    this.#rmp.dom.video.removeEventListener('leavepictureinpicture', this.#leavepictureinpictureFn);
  }

  destroy() {
    return new Promise(resolve => {
      if (this.#rmp.dom.video && this.#rmp.dom.video.webkitSupportsPresentationMode &&
        typeof this.#rmp.dom.video.webkitSetPresentationMode === 'function') {
        Logger.print('pip', 'destroy for webkitPresentationMode');
        if (this.#rmp.dom.video.webkitPresentationMode === 'picture-in-picture') {
          this.#rmp.dom.video.webkitSetPresentationMode('inline');
        }
        resolve();
      } else {
        Logger.print('pip', 'destroy for pictureInPictureElement');
        if (document.pictureInPictureElement) {
          document.exitPictureInPicture().then(() => {
            resolve();
          }).catch(warning => {
            console.warn(warning);
            resolve();
          });
        } else {
          resolve();
        }
      }
    });
  }

  init() {
    Logger.print('pip', 'init');
    if (typeof document.pictureInPictureEnabled !== 'undefined' || this.#rmp.dom.video.disablePictureInPicture) {
      Logger.print('pip', 'pictureInPicture API available');
      this.#rmp.one('loadedmetadata', this.#onLoadedmetadataPiP.bind(this));
    } else if (this.#rmp.dom.video.webkitSupportsPresentationMode &&
      typeof this.#rmp.dom.video.webkitSetPresentationMode === 'function') {
      Logger.print('pip', 'webkitSupportsPresentationMode API available');
      this.#rmp.one('loadedmetadata', this.#onLoadedmetadataPiPSafari.bind(this));
    }
  }

}
